namespace Matrix {

    @Serenity.Decorators.registerEditor("Matrix.ReadOnlyDateTime", [Serenity.IGetEditValue, Serenity.ISetEditValue])
    @Serenity.Decorators.element("<div/>")
    export class ReadOnlyDateTime extends Serenity.TemplatedWidget<any>
        implements Serenity.IGetEditValue, Serenity.ISetEditValue {

        constructor(div: JQuery) {
            super(div);
        }

        private formattedDateValueAsString: string;
        private dateValueAsString: string;

        protected getTemplate() {
            return "<div id='~_Date' class='s-StaticTextBlock'>-- No data --</div>";
        }

        protected updateContent() {
            var dateDiv = this.byId('Date');
            dateDiv.text(Q.coalesce(this.formattedDateValueAsString, ''));
        }

        public get value(): string {
            return this.dateValueAsString;
        }

        public set value(value: string) {
            this.dateValueAsString = value;
            if (!value)
                this.formattedDateValueAsString = '';
            else {
                try {
                    var dt = new Date(value);
                    this.formattedDateValueAsString = dt.toLocaleDateString().concat(' ', dt.toLocaleTimeString());
                } catch (e) {
                    this.formattedDateValueAsString = '';
                }
            }

            this.updateContent();
        }

        public getEditValue(prop: Serenity.PropertyItem, target) {
            target[prop.name] = this.value;
        }

        public setEditValue(source, prop: Serenity.PropertyItem) {
            this.value = source[prop.name];
        }

        public onChange: () => void;
    }
}